<template>
  <div>
    <template v-if="jenis === 'daring' ? false : !show">
      <v-card outlined class="pa-5">
        <v-card-text class="ma-2">
          <v-row dense>
            <v-col cols="12" md="10" sm="12">
              <h3>Selamat Datang di</h3>
              <h2 class="mt-2 black--text">{{ labels[jenis][0] }}</h2>
              <div class="my-2 black--text">
                {{ labels[jenis][1] }}
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <v-img
                src="https://cdn.siap.id/s3/simpkb/asset%20img/ayo%20guru%20belajar%20&%20berbagi/GTK-PAUD/ilust-diklat-berjenjang.png"
                style="transform: scaleX(-1)"
              ></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-row class="py-3">
        <v-col cols="12" md="4" sm="12">
          <v-card outlined tile @click="show = true">
            <v-list-item>
              <v-list-item-icon>
                <v-icon size="80" color="secondary">mdi-format-list-text</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item light>
              <v-list-item-content>
                <div class="title h mb-1">{{ labels[jenis][2] }}</div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col v-if="$allow('lpd-luring-sertifikat.index') && jenis === 'luring'" cols="12" md="4" sm="12">
          <v-card outlined tile @click="$router.push({ name: 'luring-sertifikat' })">
            <v-list-item>
              <v-list-item-icon>
                <v-icon size="80" color="secondary">mdi-certificate</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item light>
              <v-list-item-content>
                <div class="title h mb-1">Sertifikat Diklat Luring Tersistem</div>
                <div class="grey--text caption"> </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col v-if="$allow('bcmp-sertifikat.index') && jenis === 'bcmp'" cols="12" md="4" sm="12">
          <v-card outlined tile @click="$router.push({ name: 'bcmp-sertifikat' })">
            <v-list-item>
              <v-list-item-icon>
                <v-icon size="80" color="secondary">mdi-certificate</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item light>
              <v-list-item-content>
                <div class="title h mb-1">Sertifikat BCMP</div>
                <div class="grey--text caption"> </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <list-diklat v-if="show ? true : jenis === 'daring'" :jenis="jenis" :actions="actions" :akses="akses" />
  </div>
</template>
<script>
import actions from '../diklat/actions';
import ListDiklat from '../diklat/Index';
export default {
  components: { ListDiklat },
  data() {
    return {
      show: false,
      labels: {
        luring: [
          'Diklat Luring Tersistem | DIKLAT BERJENJANG PAUD',
          'Diklat Luring Tersistem merupakan suatu program yang dirancang untuk meningkatkan pengetahuan, ketrampilan dan sikap guru PAUD dalam melaksanakan tugas secara profesional melalui tahap Pendalaman Materi dan tahap Tugas Mandiri',
          'Daftar Diklat Luring Tersistem',
        ],
        bcmp: [
          'Bimtek Calon Master Pelatih | DIKLAT BERJENJANG PAUD',
          'Diklat Bimtek Calon Master Pelatih merupakan suatu program yang dirancang untuk mempersiapkan guru PAUD agar memiliki kompetensi sesuai standar profesional guru PAUD.',
          'Daftar Bimtek',
        ],
        refreshment: [
          'Bimtek Pengajar dan Pembimbing Praktik | DIKLAT BERJENJANG PAUD',
          'Pendalaman Materi dan Bimtek Pembekalan Pembimbing Praktik Tugas Mandiri',
          'Daftar Bimtek',
        ],
      },
    };
  },
  computed: {
    jenis() {
      return this.$route.meta.tipe;
    },

    actions() {
      return actions[this.jenis];
    },

    akses() {
      const acl = {
        daring: 'lpd-diklat',
        bcmp: 'bcmp-diklat',
        refreshment: 'lpd-bimtek-diklat',
        luring: 'lpd-luring-diklat',
      };

      return acl[this.jenis];
    },
  },
};
</script>
